import { render, staticRenderFns } from "./PurchaseOverview.vue?vue&type=template&id=2cefd505"
import script from "./PurchaseOverview.vue?vue&type=script&lang=ts"
export * from "./PurchaseOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports